<template>
  <div class="rules-create">
    <notifications group="edit-rule" position="top center" />
    <div class="card">
      <div class="card-header">
        <h3 class="mb-0 text-center">Edit Rule</h3>
      </div>
      <div class="card-body">
        <div class="mb-4">
          <p>IP: {{ $route.params.ip }}</p>
          <div class="d-flex justify-content-between align-items-center">
            <div class="searchbar">
              <TextInput
                class="my-0"
                placeholder="Enter search query..."
                v-model="query"
              />
            </div>
            <div>
              <button
                class="btn btn-primary"
                v-if="
                  filteredBlocks.length &&
                  !filteredBlocks[filteredBlocks.length - 1].new &&
                  filteredBlocks.length > 1
                "
                @click.prevent="reOrderMode = !reOrderMode"
              >
                Re-order Rules
              </button>
            </div>
          </div>
        </div>
        <b-form id="createrule">
          <loading
            :active.sync="loading"
            :can-cancel="false"
            color="#2196f3"
            :z-index="9"
            :is-full-page="fullPage"
          ></loading>
          <draggable
            v-model="form.blocks"
            handle=".handleBlocks"
            :disabled="filteredBlocks.length <= 1"
          >
            <transition-group>
              <div
                class="card mb-5"
                v-for="(block, i) in filteredBlocks"
                :key="`block-${i}`"
              >
                <div
                  class="p-4 card-header d-flex justify-content-between align-items-center"
                >
                  <div class="card-title mb-0">
                    <h3
                      class="card-label mb-0"
                      v-if="!block.editable && filteredBlocks[i].title"
                    >
                      {{ filteredBlocks[i].title }}
                    </h3>
                    <b-form-input
                      v-else
                      :disabled="!block.editable"
                      v-model="filteredBlocks[i].title"
                      type="text"
                      placeholder="Enter title"
                    >
                    </b-form-input>
                  </div>
                  <div class="card-toolbar d-flex">
                    <button
                      class="btn bg-primary text-white border-0 mx-3"
                      @click.prevent="duplicateBlock(filteredBlocks[i])"
                    >
                      Duplicate
                    </button>
                    <button
                      class="btn bg-white border-0 mx-3"
                      :aria-expanded="
                        filteredBlocks[i].visible ? 'true' : 'false'
                      "
                      @click.prevent="
                        filteredBlocks[i].visible = !filteredBlocks[i].visible
                      "
                    >
                      <i
                        class="fa text-dark"
                        :class="
                          filteredBlocks[i].visible
                            ? 'fa-chevron-down'
                            : 'fa-chevron-up'
                        "
                      ></i>
                    </button>
                    <button
                      class="btn bg-white handleBlocks"
                      v-show="reOrderMode && !block.new"
                      @click.prevent=""
                    >
                      <i class="fa fa-align-justify text-dark"></i>
                    </button>
                  </div>
                </div>
                <b-collapse v-model="filteredBlocks[i].visible">
                  <div class="d-flex justify-content-end align-items-center">
                    <div>
                      <button
                        v-if="!block.new"
                        class="btn btn-danger mt-2 p-2 mr-2"
                        @click.prevent="openDeletePopup(block.id)"
                      >
                        Delete
                      </button>
                      <button
                        v-if="block.status && !block.new"
                        @click.prevent="disableBlock(i, block.id)"
                        class="btn p-2 mt-2 mr-2 btn btn-warning"
                      >
                        Disable
                      </button>
                      <button
                        v-if="!block.status && !block.new"
                        @click.prevent="enableBlock(i, block.id)"
                        class="btn p-2 mt-2 mr-2 btn btn-success"
                      >
                        Enable
                      </button>
                      <button
                        v-if="!block.editable && !block.new"
                        @click.prevent="makeBlockEditable(i)"
                        class="btn p-0 mt-2 mr-2"
                      >
                        <i class="flaticon-edit"></i>
                      </button>
                      <button
                        v-if="block.editable && !block.new"
                        @click.prevent="makeBlockNotEditable(i)"
                        class="btn p-0 mt-2 mr-2"
                      >
                        <i class="flaticon-close"></i>
                      </button>
                    </div>
                  </div>

                  <div
                    class="card-body"
                    :class="block.editable ? '' : 'disabled'"
                  >
                    <h5 class="text-primary mb-5">Match:</h5>
                    <draggable
                      v-model="filteredBlocks[i].match"
                      handle=".handle"
                      :disabled="filteredBlocks[i].match.length <= 1"
                    >
                      <transition-group>
                        <div
                          class="d-flex"
                          v-for="(match, j) in filteredBlocks[i].match"
                          :key="'match' + j"
                        >
                          <div class="d-flex align-self-center">
                            <i class="fa fa-align-justify handle"></i>
                          </div>
                          <div class="col-4">
                            <b-form-group label="Condition Name">
                              <b-form-select
                                v-model="
                                  filteredBlocks[i].match[j].condition_name
                                "
                                :options="conditionNames"
                              >
                                <template v-slot:first>
                                  <b-form-select-option value=""
                                    >Select Condition Name</b-form-select-option
                                  >
                                </template></b-form-select
                              >
                              <span
                                v-if="
                                  error[
                                    'rules.' +
                                      i +
                                      '.match.' +
                                      j +
                                      '.condition_name'
                                  ]
                                "
                                class="text-danger"
                              >
                                {{
                                  error[
                                    "rules." +
                                      i +
                                      ".match." +
                                      j +
                                      ".condition_name"
                                  ]
                                }}
                              </span>
                              <span
                                v-if="error['match.' + j + '.condition_name']"
                                class="text-danger"
                              >
                                {{ error["match." + j + ".condition_name"] }}
                              </span>
                            </b-form-group>
                          </div>
                          <div class="col-4">
                            <b-form-group label="Operator">
                              <b-form-select
                                v-model="filteredBlocks[i].match[j].operator"
                                :options="operators"
                              >
                                <template v-slot:first>
                                  <b-form-select-option value=""
                                    >Select Operator</b-form-select-option
                                  >
                                </template></b-form-select
                              >
                              <span
                                v-if="error['match.' + j + '.operator']"
                                class="text-danger"
                              >
                                {{ error["match." + j + ".operator"] }}
                              </span>
                              <span
                                v-if="error['match.' + j + '.operator']"
                                class="text-danger"
                              >
                                {{ error["match." + j + ".operator"] }}
                              </span>
                            </b-form-group>
                          </div>
                          <div class="col-4">
                            <b-form-group label="Value">
                              <b-form-input
                                v-model="filteredBlocks[i].match[j].value"
                                type="text"
                              >
                              </b-form-input>
                              <span
                                v-if="
                                  error['rules.' + i + '.match.' + j + '.value']
                                "
                                class="text-danger"
                              >
                                {{
                                  error["rules." + i + ".match." + j + ".value"]
                                }}
                              </span>
                              <span
                                v-if="error['match.' + j + '.value']"
                                class="text-danger"
                              >
                                {{ error["match." + j + ".value"] }}
                              </span>
                            </b-form-group>
                          </div>
                          <div class="align-self-center">
                            <button
                              class="btn p-0"
                              @click.prevent="removeMatch(i, j)"
                            >
                              <i class="fa fa-times text-danger"></i>
                            </button>
                          </div>
                        </div>
                      </transition-group>
                    </draggable>
                    <div class="text-right">
                      <button
                        @click.prevent="addMatch(i)"
                        class="btn btn-default"
                      >
                        <i class="fa fa-plus"></i>
                      </button>
                    </div>
                    <h5 class="text-primary mb-5">Deploy:</h5>
                    <draggable
                      v-model="filteredBlocks[i].deploy"
                      handle=".handle"
                      :disabled="filteredBlocks[i].deploy.length <= 1"
                    >
                      <transition-group>
                        <div
                          class="d-flex flex-wrap"
                          v-for="(deploy, j) in filteredBlocks[i].deploy"
                          :key="'deploy' + j"
                        >
                          <div class="d-flex align-self-center">
                            <i class="fa fa-align-justify handle"></i>
                          </div>
                          <div class="col">
                            <b-form-group label="Variable Name">
                              <b-form-select
                                v-model="
                                  filteredBlocks[i].deploy[j].variable_name
                                "
                                :options="variable_names"
                                @change="(value) => detectContinue(value, i, j)"
                              >
                                <template v-slot:first>
                                  <b-form-select-option value=""
                                    >Select Variable Name</b-form-select-option
                                  >
                                </template></b-form-select
                              >
                              <span
                                v-if="
                                  error[
                                    'rules.' +
                                      i +
                                      '.deploy.' +
                                      j +
                                      '.variable_name'
                                  ]
                                "
                                class="text-danger"
                              >
                                {{
                                  error[
                                    "rules." +
                                      i +
                                      ".deploy." +
                                      j +
                                      ".variable_name"
                                  ]
                                }}
                              </span>
                              <span
                                v-if="error['deploy.' + j + '.variable_name']"
                                class="text-danger"
                              >
                                {{ error["deploy." + j + ".variable_name"] }}
                              </span>
                            </b-form-group>
                          </div>
                          <div class="col">
                            <b-form-group
                              class="varNameTypes"
                              label="Variable Name Value"
                              :description="
                                filteredBlocks[i].deploy[j].variable_name ==
                                'continue'
                                  ? 'Please enter true or false'
                                  : ''
                              "
                            >
                              <b-input-group>
                                <b-input-group-prepend is-text>
                                  <b-form-radio-group
                                    id="btn-radios-1"
                                    v-model="
                                      filteredBlocks[i].deploy[j].varNameType
                                    "
                                    :options="varNameTypes"
                                    name="radios-btn-default"
                                    value-field="value"
                                    text-field="text"
                                    button-variant="outline-primary"
                                    buttons
                                    @change="
                                      (value) => resetValues(value, i, j)
                                    "
                                  ></b-form-radio-group>
                                </b-input-group-prepend>
                                <b-form-select
                                  v-if="
                                    filteredBlocks[i].deploy[j].varNameType ==
                                    'fun'
                                  "
                                  v-model="
                                    filteredBlocks[i].deploy[j]
                                      .variable_name_value
                                  "
                                  :options="functions"
                                  text-field="name"
                                  value-field="value"
                                  @change="(value) => showParams(value, i, j)"
                                >
                                  <template v-slot:first>
                                    <b-form-select-option value=""
                                      >Select Function
                                      Name</b-form-select-option
                                    >
                                  </template></b-form-select
                                >
                                <b-form-input
                                  v-if="
                                    filteredBlocks[i].deploy[j].varNameType ==
                                    'text'
                                  "
                                  v-model="
                                    filteredBlocks[i].deploy[j]
                                      .variable_name_value
                                  "
                                  type="text"
                                  placeholder="Enter Variable Name"
                                >
                                </b-form-input>
                                <span
                                  v-if="
                                    error[
                                      'rules.' +
                                        i +
                                        '.deploy.' +
                                        j +
                                        '.variable_name_value'
                                    ]
                                  "
                                  class="text-danger"
                                >
                                  {{
                                    error[
                                      "rules." +
                                        i +
                                        ".deploy." +
                                        j +
                                        ".variable_name_value"
                                    ]
                                  }}
                                </span>
                                <span
                                  v-if="
                                    error[
                                      'deploy.' + j + '.variable_name_value'
                                    ]
                                  "
                                  class="text-danger"
                                >
                                  {{
                                    error[
                                      "deploy." + j + ".variable_name_value"
                                    ]
                                  }}
                                </span>
                              </b-input-group>
                            </b-form-group>
                          </div>
                          <div
                            class="col d-flex"
                            v-if="
                              filteredBlocks[i].deploy[j].varNameType == 'fun'
                            "
                          >
                            <b-form-group
                              class="varNameTypes"
                              v-for="(param, k) in filteredBlocks[i].deploy[j]
                                .params"
                              :key="'param' + k"
                              :label="'Parameter ' + (k + 1)"
                            >
                              <b-form-input
                                v-model="form.blocks[i].deploy[j].params[k]"
                                type="text"
                                placeholder="Enter Variable Name"
                              >
                              </b-form-input>
                            </b-form-group>
                          </div>
                          <div class="align-self-center">
                            <button
                              class="btn p-0"
                              @click.prevent="removeDeploy(i, j)"
                            >
                              <i class="fa fa-times text-danger"></i>
                            </button>
                          </div>
                        </div>
                      </transition-group>
                    </draggable>
                    <span
                      v-if="error['rules.' + i + '.deploy']"
                      class="text-danger"
                    >
                      {{ error["rules." + i + ".deploy"] }}
                    </span>
                    <div class="text-right">
                      <button
                        @click.prevent="addDeploy(i)"
                        class="btn btn-default"
                      >
                        <i class="fa fa-plus"></i>
                      </button>
                    </div>
                  </div>

                  <div class="text-center" v-if="block.editable && !block.new">
                    <button
                      @click.prevent="updateBlock(i, block.id)"
                      class="btn btn-primary mb-2"
                    >
                      Update
                    </button>
                  </div>
                  <div class="text-center" v-if="block.editable && block.new">
                    <button
                      @click.prevent="addRule"
                      class="btn btn-primary mb-2"
                    >
                      Add
                    </button>
                  </div>
                </b-collapse>
              </div>
            </transition-group>
          </draggable>
        </b-form>
        <div class="text-center" v-if="!filteredBlocks.length">
          No Rules Available
        </div>
        <div class="text-right">
          <button
            @click.prevent="addBlock"
            v-if="
              !filteredBlocks.length ||
              !filteredBlocks[filteredBlocks.length - 1].new
            "
            class="btn btn-default"
          >
            <i class="fa fa-plus"></i>
          </button>
        </div>
      </div>
    </div>
    <modal name="deletePopup" :width="500" height="auto" @closed="clearData">
      <div class="container pt-10 vld-parent pb-5">
        <loading
          :active.sync="deleteLoading"
          :can-cancel="false"
          color="#2196f3"
          :z-index="9"
          :is-full-page="fullPage"
        ></loading>
        <h1 class="color-primary text-center mb-5">Delete Rule</h1>
        <form
          class="delete-banner__form text-center"
          @submit.prevent="deleteHandler"
          id="delete-banner"
        >
          <p>Are you sure you want to delete this Rule?</p>
          <div class="row justify-content-center mt-5">
            <button class="btn btn-danger rounded w-20">Delete</button>
          </div>
        </form>
      </div>
    </modal>
    <div class="text-center mt-10">
      <button
        type="submit"
        @click.prevent="confirmOrder"
        v-show="reOrderMode"
        class="btn btn-primary"
      >
        Confirm order
      </button>
    </div>
  </div>
</template>

<script>
import FileSaver from "file-saver";
import draggable from "vuedraggable";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import _ from "lodash";
import http from "@/axios";
import TextInput from "@/components/TextInput.vue";
export default {
  data() {
    return {
      query: "",
      conditionNames: [],
      operators: [
        "equal",
        "!equal",
        "startwith",
        "!startwith",
        "existin_url",
        "!existin_url",
        "between",
        "!between",
      ],
      variable_names: [],
      deleteLoading: false,
      reOrderMode: false,
      currentRule: null,
      functions: [
        { name: "func_strip", value: { name: "func_strip", params: 1 } },
        {
          name: "func_do_strip_append",
          value: { name: "func_do_strip_append", params: 2 },
        },
        { name: "func_append", value: { name: "func_append", params: 1 } },
        { name: "url", value: { name: "url", params: 1 } },
      ],
      varNameTypes: [
        { text: "Function", value: "fun" },
        { text: "Text", value: "text" },
      ],
      varNameType: "fun",
      loading: false,
      fullPage: false,
      switchIcon: false,
      error: {},
      form: {
        blocks: [
          {
            title: "",
            match: [{ condition_name: "", operator: "", value: "" }],
            deploy: [
              {
                variable_name: "",
                variable_name_value: "",
                varNameType: "fun",
                params: [],
              },
            ],
          },
        ],
      },
    };
  },
  components: {
    draggable,
    TextInput,
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "IP Profiles", route: "ip-profiles/all" },
      { title: "Edit IP Profile Rule" },
    ]);
  },
  created() {
    this.getRules(this.$route.params.id);
    this.getVariableNames();
    this.getConditionNames();
  },
  methods: {
    async getVariableNames() {
      this.loading = true;

      try {
        const res = await http.get("/sbc/variables/deploy");
        this.variable_names = res.data.data.map(({ name, key }) => ({
          text: name,
          value: key,
        }));
        this.loading = false;
      } catch (error) {
        this.$notify({
          group: "settings",
          title: error.response.data.message,
          type: "error",
        });
        this.loading = false;
      }
    },
    async getConditionNames() {
      this.loading = true;

      try {
        const res = await http.get("/sbc/variables/match");
        this.conditionNames = res.data.data.map(({ name, key }) => ({
          text: name,
          value: key,
        }));
        this.loading = false;
      } catch (error) {
        this.$notify({
          group: "settings",
          title: error.response.data.message,
          type: "error",
        });
        this.loading = false;
      }
    },
    async getRules(id) {
      this.loading = true;
      await http
        .get(`sbc/ips/rules/${id}`)
        .then((res) => {
          var rules = res.data.data;
          for (let i = 0; i < rules.length; i++) {
            rules[i].editable = false;
            rules[i].new = false;
            rules[i].visible = false;
            if (Array.isArray(rules[i].deploy)) {
              for (let j = 0; j < rules[i].deploy.length; j++) {
                if (rules[i].deploy[j].variable_name_value == null) {
                  rules[i].deploy[j].variable_name_value = "";
                }

                if (
                  rules[i].deploy[j].variable_name_value.includes("func_") ||
                  rules[i].deploy[j].variable_name_value.includes("url")
                ) {
                  rules[i].deploy[j].varNameType = "fun";
                } else {
                  rules[i].deploy[j].varNameType = "text";
                }

                let params = this.exludeParams(
                  rules[i].deploy[j].variable_name_value
                );

                if (Array.isArray(params)) {
                  rules[i].deploy[j].variable_name_value = {
                    name: rules[i].deploy[j].variable_name_value.split("(")[0],
                    params: params.length,
                  };
                  rules[i].deploy[j].params = [];
                  for (let k = 0; k < params.length; k++) {
                    rules[i].deploy[j].params.push(params[k]);
                  }
                } else {
                  if (rules[i].deploy[j].varNameType == "text") {
                    rules[i].deploy[j].variable_name_value =
                      rules[i].deploy[j].variable_name_value;
                  } else {
                    rules[i].deploy[j].variable_name_value = {
                      name: rules[i].deploy[j].variable_name_value.split(
                        "("
                      )[0],
                      params: 1,
                    };
                    rules[i].deploy[j].params = [];
                    rules[i].deploy[j].params.push(params);
                  }
                }
              }
            }
          }
          this.$forceUpdate();

          this.form.blocks = rules;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    confirmOrder() {
      this.loading = true;
      if (this.form.blocks.length) {
        let blockIds = this.form.blocks.map((block) => {
          return block.id;
        });
        http
          .put(`sbc/ips/rules/re-order`, { ids: blockIds })
          .then((res) => {
            this.$notify({
              group: "edit-rule",
              title: res.data.message,
              type: "success",
            });
            this.getRules(this.$route.params.id);
            this.loading = false;
            this.reOrderMode = false;
          })
          .catch((err) => {
            this.$notify({
              group: "edit-rule",
              title: "Something went wrong!",
              type: "error",
            });
            this.loading = false;
          });
        this.loading = false;
      }
    },
    openDeletePopup(id) {
      this.currentRule = id;
      this.$modal.show("deletePopup");
    },
    clearData() {
      this.currentRule = null;
    },
    detectContinue(value, i, j) {
      if (value == "continue" || value == "rtp_server") {
        this.form.blocks[i].deploy[j].varNameType = "text";
        this.resetValues(value, i, j);
      }
    },
    async setStatus(i, status, id) {
      this.loading = true;
      await http
        .put(`/sbc/ips/rules/update-status/${id}`)
        .then((res) => {
          this.$notify({
            group: "edit-rule",
            title: res.data.message,
            type: "success",
          });
          this.loading = false;
        })
        .catch((err) => {});
    },
    makeBlockEditable(i) {
      this.form.blocks[i].editable = true;
    },
    async disableBlock(i, id) {
      this.loading = true;
      await http
        .put(`/sbc/ips/rules/update-status/${id}`, { status: 0 })
        .then((res) => {
          this.$notify({
            group: "edit-rule",
            title: res.data.message,
            type: "success",
          });
          this.getRules(this.$route.params.id);
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    async enableBlock(i, id) {
      this.loading = true;
      await http
        .put(`/sbc/ips/rules/update-status/${id}`, { status: 1 })
        .then((res) => {
          this.$notify({
            group: "edit-rule",
            title: res.data.message,
            type: "success",
          });
          this.getRules(this.$route.params.id);
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    makeBlockNotEditable(i) {
      this.form.blocks[i].editable = false;
    },
    async deleteHandler() {
      this.deleteLoading = true;
      await http
        .delete(`/sbc/ips/rules/${this.currentRule}`)
        .then((res) => {
          setTimeout(() => {
            this.$modal.hide("deletePopup");
            this.deleteLoading = false;
          }, 500);
          this.currentRule = null;
          this.getRules(this.$route.params.id);
          this.$notify({
            group: "edit-rule",
            title: "Rule Deleted Successfully!",
            type: "success",
          });
        })
        .catch((err) => {
          this.$notify({
            group: "edit-rule",
            title: "Something went wrong!",
            type: "error",
          });
          this.deleteLoading = false;
        });
    },
    exludeParams(value) {
      if (!value.startsWith("func") && !value.startsWith("url")) {
        return value;
      }
      if (value.startsWith("func_strip")) {
        let valueAfterRemovingFunction = value
          .replace("func_strip(", "")
          .replace(")", "");
        return valueAfterRemovingFunction;
      }
      if (value.startsWith("func_append")) {
        let valueAfterRemovingFunction = value
          .replace("func_append(", "")
          .replace(")", "");
        return valueAfterRemovingFunction;
      }
      if (value.startsWith("url")) {
        let valueAfterRemovingFunction = value
          .replace("url(", "")
          .replace(")", "");
        return valueAfterRemovingFunction;
      }
      if (value.startsWith("func_do_strip_append")) {
        let valueAfterRemovingFunction = value
          .replace("func_do_strip_append(", "")
          .replace(")", "");
        let explodedParamaters = valueAfterRemovingFunction.split(",");
        return explodedParamaters;
      }
    },
    updateBlock(i, id) {
      this.loading = true;
      this.error = {};
      let payload = JSON.parse(JSON.stringify(this.form.blocks[i]));
      if (Array.isArray(payload.deploy)) {
        for (let j = 0; j < payload.deploy.length; j++) {
          if (payload.deploy[j].varNameType == "fun") {
            payload.deploy[j].variable_name_value = `${
              payload.deploy[j].variable_name_value.name
            }(${payload.deploy[j].params.join(",")})`;
          }
        }
      }
      delete payload.editable;
      delete payload.new;
      delete payload.visible;

      if (Array.isArray(payload.deploy)) {
        payload.deploy.forEach(function (d) {
          delete d.params;
          delete d.varNameType;
        });
      }
      http
        .put(`/sbc/ips/rules/${id}`, { ...payload, index: i })
        .then((res) => {
          this.loading = false;
          this.form.blocks[i].editable = false;
          this.error = {};
          this.$notify({
            group: "edit-rule",
            title: res.data.message,
            type: "success",
          });
        })
        .catch((err) => {
          this.error = err.response.data.error;
          if (err.response.data.message) {
            this.$notify({
              group: "edit-rule",
              title: err.response.data.message,
              type: "error",
            });
          }
          this.loading = false;
        });
    },
    async addRule() {
      this.loading = true;
      this.error = {};
      let payload = JSON.parse(
        JSON.stringify(this.form.blocks[this.form.blocks.length - 1])
      );

      for (let j = 0; j < payload.deploy.length; j++) {
        if (payload.deploy[j].varNameType == "fun") {
          payload.deploy[j].variable_name_value = `${
            payload.deploy[j].variable_name_value.name
          }(${payload.deploy[j].params.join(",")})`;
        }
      }

      if (payload.deploy.length) {
        payload.deploy.forEach(function (d) {
          delete d.params;
          delete d.varNameType;
        });
      }
      delete payload.new;
      delete payload.editable;
      delete payload.visible;
      let newBlock = [payload];

      await http
        .post(`sbc/ips/rules/${this.$route.params.id}`, { rules: newBlock })
        .then((res) => {
          this.$notify({
            group: "edit-rule",
            title: "Rule added successfully.",
            type: "success",
          });
          this.error = {};
          this.getRules(this.$route.params.id);
          this.loading = false;
        })
        .catch((err) => {
          this.error = err.response.data.error;
          if (err.response.data.message) {
            this.$notify({
              group: "rules",
              title: err.response.data.message,
              type: "error",
            });
          }
          this.loading = false;
        });
      this.loading = false;
    },
    resetValues(value, i, j) {
      this.form.blocks[i].deploy[j].variable_name_value = "";
      this.form.blocks[i].deploy[j].params = [];
    },
    addBlock() {
      this.form.blocks.push({
        title: "",
        match: [{ condition_name: "", operator: "", value: "" }],
        deploy: [
          { variable_name: "", variable_name_value: "", varNameType: "fun" },
        ],
        editable: true,
        new: true,
        visible: true,
      });
    },
    removeMatch(i, j) {
      this.form.blocks[i].match.splice(j, 1);
    },
    removeDeploy(i, j) {
      this.form.blocks[i].deploy.splice(j, 1);
    },
    addMatch(i) {
      if (!Array.isArray(this.form.blocks[i].match)) {
        this.form.blocks[i].match = [];
        this.form.blocks[i].match.push({
          condition_name: "",
          operator: "",
          value: "",
        });
      } else {
        this.form.blocks[i].match.push({
          condition_name: "",
          operator: "",
          value: "",
        });
      }
    },
    showParams(value, i, j) {
      this.form.blocks[i].deploy[j].params = [];
      this.form.blocks[i].deploy[j].params.push("");
      if (value.params > 1) {
        this.form.blocks[i].deploy[j].params = _.fill(Array(value.params), "");
        this.$forceUpdate();
      }
      this.$forceUpdate();
    },

    addDeploy(i) {
      if (!Array.isArray(this.form.blocks[i].deploy)) {
        this.form.blocks[i].deploy = [];
        this.form.blocks[i].deploy.push({
          variable_name: "",
          variable_name_value: "",
          varNameType: "fun",
        });
      } else {
        this.form.blocks[i].deploy.push({
          variable_name: "",
          variable_name_value: "",
          varNameType: "fun",
        });
      }
    },
    duplicateBlock(block) {
      this.form.blocks.push({ ...block, id: new Date().getTime() });
      this.addRule();
    },
  },
  computed: {
    filteredBlocks() {
      const blocks = this.form.blocks.filter((block) =>
        block.title.toLowerCase().includes(this.query.toLowerCase())
      );
      return blocks;
    },
  },
};
</script>

<style lang="scss">
.handle,
.handleBlocks {
  cursor: move;
}
.card-body.disabled {
  pointer-events: none;
  opacity: 0.7;
}
.flaticon-edit,
.flaticon-close {
  font-weight: bolder;
  font-size: 20px !important;
  color: #2196f3 !important;
}
.varNameTypes {
  .input-group-text {
    padding: 0 !important;
    background-color: #fff !important;
  }
  .custom-select,
  input[type="text"] {
    height: 40px;
  }
  .btn.btn-outline-primary {
    color: #111;
    background-color: transparent;
    border-color: #f3f6f9;
    border-radius: 0;
  }

  .btn.btn-outline-primary:not(:disabled):not(.disabled):active:not(.btn-text),
  .btn.btn-outline-primary:not(:disabled):not(.disabled).active,
  .show > .btn.btn-outline-primary.dropdown-toggle,
  .show .btn.btn-outline-primary.btn-dropdown {
    background-color: #f3f6f9;
    border-color: #f3f6f9;
    color: #111;
  }
}
</style>
